// @flow
import {
    CHANGE_LAYOUT,
    CHANGE_LAYOUT_WIDTH,
    CHANGE_SIDEBAR_THEME,
    CHANGE_SIDEBAR_TYPE,
    TOGGLE_RIGHT_SIDEBAR,
    SHOW_RIGHT_SIDEBAR,
    HIDE_RIGHT_SIDEBAR,
    CHANGE_COLUMN_SERVICE,
    CHANGE_COLUMN_EXAM,
    CHANGE_COLUMN_BOOKING,
    CHANGE_COLUMN_WAITING,
    CHANGE_COLUMN_RUNING,
    CHANGE_COLUMN_DONE,
    CHANGE_COLUMN_CANCEL,
    CHANGE_COLUMN_CANCELLING,
    CHANGE_COLUMN_ORDER,
} from './constants';

import * as layoutConstants from '../../constants/layout';

const INIT_STATE = {
    layoutType: layoutConstants.LAYOUT_VERTICAL,
    layoutWidth: layoutConstants.LAYOUT_WIDTH_FLUID,
    leftSideBarTheme: layoutConstants.LEFT_SIDEBAR_THEME_DEFAULT,
    leftSideBarType: layoutConstants.LEFT_SIDEBAR_TYPE_FIXED,
    showRightSidebar: false,
    columnService: layoutConstants.COLUMN_SERVICE,
    columnBooking: layoutConstants.COLUMN_SERVICE_BK,
    columnWaiting: layoutConstants.COLUMN_SERVICE,
    columnRuning: layoutConstants.COLUMN_SERVICE,
    columnDone: layoutConstants.COLUMN_SERVICE,
    columnCancel: layoutConstants.COLUMN_SERVICE,
    columnCancelling: layoutConstants.COLUMN_SERVICE,
    columnOrder: layoutConstants.COLUMN_ORDER,
};


const Layout = (state = INIT_STATE, action: any) => {
    switch (action.type) {
        case CHANGE_LAYOUT:
            return {
                ...state,
                layoutType: action.payload,
            };
        case CHANGE_LAYOUT_WIDTH:
            return {
                ...state,
                layoutWidth: action.payload,
            };
        case CHANGE_SIDEBAR_THEME:
            return {
                ...state,
                leftSideBarTheme: action.payload,
            };
        case CHANGE_SIDEBAR_TYPE:
            return {
                ...state,
                leftSideBarType: action.payload,
            };
        case TOGGLE_RIGHT_SIDEBAR:
            return {
                ...state,
                showRightSidebar: !state.showRightSidebar,
            };
        case SHOW_RIGHT_SIDEBAR:
            return {
                ...state,
                showRightSidebar: true,
            };
        case HIDE_RIGHT_SIDEBAR:
            return {
                ...state,
                showRightSidebar: false,
            };
        case CHANGE_COLUMN_SERVICE:
            return {
                ...state,
                columnService: action?.payload,
            };
        case CHANGE_COLUMN_EXAM:
            return {
                ...state,
                columnExam: action?.payload,
            };
        case CHANGE_COLUMN_BOOKING:
            return {
                ...state,
                columnBooking: action?.payload,
            };
        case CHANGE_COLUMN_WAITING:
            return {
                ...state,
                columnWaiting: action?.payload,
            };
        case CHANGE_COLUMN_RUNING:
            return {
                ...state,
                columnRuning: action?.payload,
            };
        case CHANGE_COLUMN_DONE:
            return {
                ...state,
                columnDone: action?.payload,
            };
        case CHANGE_COLUMN_CANCEL:
            return {
                ...state,
                columnCancel: action?.payload,
            };
        case CHANGE_COLUMN_CANCELLING:
            return {
                ...state,
                columnCancelling: action?.payload,
            };
        case CHANGE_COLUMN_ORDER:
            return {
                ...state,
                columnOrder: action?.payload,
            };
        default:
            return state;
    }
};

export default Layout;
